export default function ParklandHeroSection() {
  return (
    <section className="relative min-h-[600px] flex items-center overflow-hidden">
      {/* Background image — equestrian landscape */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20beautiful%20master-planned%20suburban%20community%20with%20lush%20green%20landscape%2C%20winding%20horse%20trails%2C%20large%20residential%20lots%20with%20mature%20trees%2C%20and%20a%20golf%20course%20in%20the%20distance%2C%20golden%20afternoon%20light%2C%20warm%20tones%2C%20no%20cars%20visible%2C%20peaceful%20Florida%20setting%2C%20professional%20real%20estate%20photography%20style&width=1400&height=700&seq=parkland-hero-1&orientation=landscape"
          alt="Parkland Florida equestrian community with horse trails and lush green landscape"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-28 md:py-36 w-full">
        <div className="max-w-2xl">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">
            Expedited Passport Services
          </p>
          <h1 className="font-serif text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
            Emergency &amp; Expedited Passport Services in <span className="text-[#F6C344]">Parkland, FL</span>
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Serving Parkland&apos;s equestrian community, families, and professionals with fast, reliable passport processing. As quick as 24 hours — no office visit required to begin.
          </p>

          <div className="flex flex-wrap items-center gap-3 mb-10">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Passport <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 text-white font-semibold text-base px-6 py-4 rounded-md border border-white/30 hover:bg-white/10 transition-all whitespace-nowrap"
            >
              <i className="ri-phone-line"></i> 877-253-0084
            </a>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2 text-white/60 text-sm">
            <span className="flex items-center gap-1.5"><i className="ri-shield-check-line text-[#F6C344]"></i> Registered State Dept. Courier</span>
            <span className="flex items-center gap-1.5"><i className="ri-time-line text-[#F6C344]"></i> 24-Hour Processing Available</span>
            <span className="flex items-center gap-1.5"><i className="ri-award-line text-[#F6C344]"></i> A+ BBB Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
}